












import { Component, Prop, Vue } from 'vue-property-decorator'
import showDiv, { closeAll } from '@ivy/fts/showDiv'

@Component({})
export default class StatusDialog extends Vue {
  @Prop({ default: {} }) goods
  close() {
    closeAll()
  }
}
